module.exports = __webpack_public_path__ + "static/media/too-many-background1.f4ccf529.jpg";